import { FC } from 'react';

import { EnquiryType } from '@shared/api/enquiry/enquiry.interface';
import { EnquiryPanel } from '@shared/containers/EnquiryForm/EnquiryPanel';

import { useStoreTitleHook } from '../hooks/useStoreTitleHook';

const StoreEnquiryPage: FC = () => {
  useStoreTitleHook('문의하기');

  //* 화환 스토어(Q&A문의)에서 들어오는 문의 — 관리자 문의사항 관리의 "스토어" 탭
  return <EnquiryPanel type={EnquiryType.Store} />;
};

export default StoreEnquiryPage;
